import React, { useState } from 'react';
import authService from '../../services/authService';
import '../../css/login.css'
import Loading from '../../components/Loading';
import { toast } from 'react-toastify';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import logo from '../../img/Logo-Colegio.png';



const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
	const [showLoading, setShowLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
		setShowLoading(true);
		try {
			const response = await authService.validateLogin(username, password);
			await onLogin(response);
		} catch (error) {
			toast.error("Usuario y/o contraseña incorrectos.", {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
			  });
			console.error("Error al loguearse:", error);
		}
		setShowLoading(false);
    };

    return (
    <div className="login-page d-flex align-items-center justify-content-center w-100">
		<div className="login-blob login-blob-1"></div>
		<div className="login-blob login-blob-2"></div>

		<div className="login-hero-card">
			<div className="row g-0 align-items-center">
				{/* Columna izquierda: marca */}
				<div className="col-lg-6 p-4 p-lg-5">
					<div className="d-flex align-items-center gap-2 mb-3">
						<LazyLoadImage
							src={logo}
							alt="Logo Gobe Campus"
							className="login-brand-logo"
							effect="blur"
						/>
						<div className="fw-bold" style={{ fontSize: "1.6rem", letterSpacing: "-0.01em" }}>
							<span style={{ color: "var(--ge-text, #16181d)" }}>Gobe</span>{" "}
							<span style={{ color: "var(--ge-primary, #3b6ff6)" }}>Campus</span>
						</div>
					</div>
					<p
						className="text-uppercase mb-4"
						style={{ fontSize: "0.75rem", letterSpacing: "0.08em", color: "var(--ge-text-muted, #8a8f98)" }}
					>
						Innovación Educativa
					</p>
					<h2 className="fw-bold mb-2" style={{ letterSpacing: "-0.01em" }}>
						Todo tu colegio, en un solo lugar
					</h2>
					<p className="text-muted mb-4" style={{ maxWidth: "380px" }}>
						Notas, asistencia, cartera y comunicación con las familias, desde
						una sola plataforma pensada para tu institución.
					</p>
				</div>

				{/* Columna derecha: formulario, tarjeta flotante */}
				<div className="col-lg-6 p-4 p-lg-5">
					<div className="card login-form-card">
						<div className="card-body p-4">
							<h4 className="mb-1">Iniciar sesión</h4>
							<p className="text-muted small mb-4">
								Ingresa con tu cuenta para continuar
							</p>

							{showLoading && <Loading />}

							{!showLoading && (
								<form onSubmit={handleSubmit}>
									<div className="mb-3">
										<label className="col-form-label text-sm-right">Usuario</label>
										<input
											className="form-control form-control-lg"
											value={username}
											onChange={(e) => setUsername(e.target.value)}
											placeholder="Usuario"
										/>
									</div>
									<div className="mb-3">
										<label className="col-form-label text-sm-right">Contraseña</label>
										<input
											className="form-control form-control-lg"
											type="password"
											value={password}
											onChange={(e) => setPassword(e.target.value)}
											placeholder="Contraseña"
										/>
									</div>
									<div className="d-grid gap-2 mt-4">
										<button className="btn btn-primary btn-lg" type="submit">
											Iniciar sesión
										</button>
									</div>
								</form>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
    );
};

export default Login;
